import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, call } from 'redux-saga/effects';
import { setPreferredLanguage } from '../../reducers/translationSlice';
import fetchTranslations from './fetchTranslationsSaga';

export function* watchLanguageChange() {
  yield takeLatest(
    setPreferredLanguage.type,
    // eslint-disable-next-line func-names
    function* (action: PayloadAction<string>) {
      yield call(fetchTranslations, action.payload);
    },
  );
}

export default function* translationSaga() {
  yield watchLanguageChange();
}
